import { EntityInfoPropertyType, EntityInfoSection, RelatedMediaSection } from 'components/shared'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { Image, Project } from 'models'
import React, { useEffect, useState } from 'react'
import { BRAND_PRODUCTS_STORE, BRAND_STORE } from 'store'
import { getMainImageSrcForObj } from 'utilities'
import styles from './BrandEditPage.module.scss'
import cl from 'classnames'
import { BrandEditPageProps } from './BrandEditPage.types'
import { ShippingOptions } from './ShippingOptions'
import { ProductsSection } from './ProductsSection'

const BrandEditPageComponent = (props: BrandEditPageProps) => {
  const {
    match: { params: { id } },
    [BRAND_STORE]: {
      getBrandById,
      brandToView,
      editBrand
    },
    [BRAND_PRODUCTS_STORE]: {
      getSearchedProducts
    }
  } = props

  useEffect(() => {
    getBrandById(id)
      .then(() => getSearchedProducts())
  }, [getBrandById, id, getSearchedProducts])

  const [brand, setBrand] = useState(brandToView.id === Number(id) ? brandToView.asDTO : null)
  useEffect(() => {
    setBrand(brandToView.id === Number(id) ? brandToView.asDTO : null)
  }, [brandToView, id])

  const saveChanges = (images?: Image[]) => {
    editBrand({ ...brand, images: images || brand.images })
  }

  const onRelatedMediaChange = (relatedMedia: Project[]) => {
    editBrand({ ...brand, relatedMedia: relatedMedia || brand.relatedMedia })
  }

  return (
    <div className={cl(styles.container, styles.scrollable)}>

      {brand && (
        <>
          <EntityInfoSection
            name={brand.name}
            mainImage={getMainImageSrcForObj(brand)}
            setName={name => setBrand(s => ({ ...s, name }))}
            ratingProps={{
              rating: brand.rating,
              reviewsCnt: brand.reviewsCnt
            }}
            images={brand.images}
            propertyFields={[
              {
                label: 'Website URL',
                type: EntityInfoPropertyType.TEXT,
                value: brand.websiteUrl,
                onChange: (websiteUrl) => setBrand(s => ({ ...s, websiteUrl }))
              },
              {
                label: 'Tags',
                type: EntityInfoPropertyType.TAGS,
                value: brand.tags,
                onChange: tags => setBrand(s => ({ ...s, tags }))
              }
            ]}
            textareaField={{
              label: 'Description',
              type: EntityInfoPropertyType.TEXT,
              value: brand.info,
              onChange: (info) => setBrand(s => ({ ...s, info }))
            }}
            saveChanges={saveChanges}
            discardChanges={() => setBrand(brandToView.asDTO)}
          />

          <RelatedMediaSection
            relatedMedia={brand.relatedMedia}
            onChange={onRelatedMediaChange}
          />

          <ShippingOptions
            shippings={brand.shippings}
          />

          <ProductsSection />
        </>
      )}

    </div>
  )
}

const BrandEditPage = inject(
  BRAND_STORE, BRAND_PRODUCTS_STORE
)(observer(BrandEditPageComponent))
export { BrandEditPage }
